import { GENERAL_CONTACT, TECH_CONTACT } from "../../lib/contacts";
import styles from "./SupportContacts.module.css";

export function MailLink({ to }: { to: string }) {
  return <a href={`mailto:${to}`}>{to}</a>;
}

// Both addresses, each named by what it is FOR, so nobody has to guess which
// one their problem belongs to. `tone="sidebar"` takes the rail's dark ink.
export function SupportContacts({ tone = "page" }: { tone?: "page" | "sidebar" }) {
  return (
    <div className={tone === "sidebar" ? styles.sidebar : styles.page}>
      <div>
        Technický kontakt: <MailLink to={TECH_CONTACT} />
      </div>
      <div>
        Ostatní dotazy: <MailLink to={GENERAL_CONTACT} />
      </div>
    </div>
  );
}
